module.exports = __webpack_public_path__ + "static/media/Body-Language-in-the-Workplace.4d6c24fe.jpg";